export default "/assets/images/dark-moss.webp?fbe0215e863f3b74317f577629287c82";